import React from "react";
import {
  Button,
  Box,
  Typography,
  Card,
  CardHeader,
  CardMedia,
  Skeleton,
} from '@mui/material';
import FloatFooter from "../Shared/FloatFooter/FloatFooter";
import InspectionStepLocalDB from "../../models/indexedDB/inspection-step-local-db.entity";

const SummaryNative = (Props: any) => {
  const {
    inspectionSteps,
    editAppletPhoto,
    getAppletName,
    goToSuccess,
    atualPlate,
    loading
  } = Props;

  return (
    <>
      <div className="header-background" />
      {loading && (
        <Box sx={{
          padding: '20px',
          marginTop: '40px',
        }}>
          <Typography variant="h2"><Skeleton /></Typography>
          <Typography variant="h2"><Skeleton /></Typography>
          <Typography variant="h2"><Skeleton /></Typography>
        </Box>
      )}
      {!loading && (
        <Box className="summary-container">
          <Box
            marginTop={'25px'}>
            <Typography
              fontWeight={600}
              fontFamily='Poppins'
              fontSize={'16px'}
              data-testid="title"
            >Resumo da vistoria</Typography>
          </Box>
          <Box
            marginTop={'22px'}>
            <Typography
              fontWeight={400}
              fontFamily='Poppins'
              fontSize={'14px'}
            >{atualPlate}</Typography>
          </Box>
          <div
            data-testid='list-container'
            className="summary-container__card"
          >
            {inspectionSteps && inspectionSteps.map((event: InspectionStepLocalDB) => {
              const { photo, id, appletSubgroupId, status } = event;
              return (
                <Card
                  data-testid='card'
                  key={id}
                  sx={{
                    border: '1px solid #BFBEBE',
                    borderRadius: '12px',
                    marginTop: '22px',
                    height: '250px',
                  }}
                >
                  <CardHeader
                    variant="outlined"
                    className="summary-item"
                    title={getAppletName(appletSubgroupId)}
                    action={
                      <div>

                        {status === 'WAITING' &&
                          <>
                            <Button
                              data-testid='flag-edit'
                              className="summary-button__red"
                              onClick={() => { editAppletPhoto(event) }}
                            >Editar</Button>
                          </>
                        }
                        {status === 'SENDING' &&
                          <>
                            <div
                              data-testid='flag-sending'
                              className="summary-button__grey"
                            >Aguardando</div>
                          </>
                        }
                        {status === 'SENT' &&
                          <>
                            <div
                              data-testid='flag-sent'
                              className="summary-button__green"
                            >Enviado</div>
                          </>
                        }
                        {status === 'WITH_ERROR' &&
                          <div className="line">
                            <div
                              data-testid='flag-sent'
                              className="summary-button__red"
                            >Nova Coleta</div>
                            <Button
                              variant="text"
                              className="summary-button__blue"
                              onClick={() => { editAppletPhoto(event) }}
                            >Editar</Button>
                          </div>
                        }
                      </div>
                    }></CardHeader>
                  <CardMedia
                    component='img'
                    height='188'
                    image={photo.data}
                  ></CardMedia>
                </Card>
              )
            })}
          </div>
          <FloatFooter>
            <Button
              fullWidth
              variant="outlined"
              className="primary-button"
              onClick={goToSuccess}
            >Salvar</Button>
          </FloatFooter>
        </Box>
      )}
    </>
  );
}

export default SummaryNative;